import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';

import { ReactComponent as ViewColumn } from 'images/Icons/ViewColumn.svg';
import { ReactComponent as ViewRow } from 'images/Icons/ViewRow.svg';

import styles from './ViewType.module.scss';

const ViewType = ({ value, handleChange }) => (
  <div>
    <IconButton onClick={() => handleChange('row')}>
      <ViewRow
        className={classNames(styles.icon, {
          [styles.activeIcon]: value === 'row',
        })}
      />
    </IconButton>
    <IconButton onClick={() => handleChange('column')}>
      <ViewColumn
        className={classNames(styles.icon, {
          [styles.activeIcon]: value === 'column',
        })}
      />
    </IconButton>
  </div>
);

ViewType.propTypes = {
  value: PropTypes.oneOf(['row', 'column']).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default memo(ViewType);
